export const ACTION_FETCH = 'fetch';
export const STORE_MODULE_NAME = 'organization';



// WEBPACK FOOTER //
// ./src/pages/organizations/card/const.ts